import React from "react";
import ButtonComp from "./ButtonComp";
import ReactHtmlParser from "react-html-parser";
import { SkeletonImage } from "./MediaWithSkeleton";

const ContentImageSection = ({
  contentSection,
  quoteText,
  paragraphs = [],
  listSectionTitle,
  listColumns = [],
  listSingleColumn = false,
  btnLink,
  btnText,
  btnClassName,
  image,
  imageClassName,
  reverse = false,
  listBottomText,
  btnImg="",
  listTopText=""
}) => {
  return (
    <div className={`align-items-center justify-content-between row content-image-section ${reverse ? "flex-row-reverse" : ""}`}>
      {/* LEFT CONTENT */}
      <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
        {/* {(highlightText || title) && (
          <h1 className="hero-title">
            {highlightText && <span className="text-success FS40FW600">{highlightText}</span>}
            {highlightText && title && <br />}
            {title}
          </h1>
        )} */}
        
        {contentSection && contentSection()}
          {listTopText && (
          <div className="mt-3"><span className="quote-para FS17FW500">{ReactHtmlParser(listTopText)}</span></div>
        )}
        {quoteText && (
          <div
            className="quote-box mt-3 FS18FW400 black"
          >{ReactHtmlParser(quoteText)}</div>
        )}

        {paragraphs.map((text, i) => (
          <p key={i} className="mt-3 FS17FW500 quote-para mb-0" dangerouslySetInnerHTML={{ __html: text }} />
        ))}

        {listColumns.length > 0 && (
          <>
            {listSectionTitle && <p className="mt-3 FS17FW500 quote-para">{ReactHtmlParser(listSectionTitle)}</p>}
            <div className={`cis-list-columns quote-list ${listSingleColumn ? "cis-list-single" : "d-flex gap-3"}`}>
              {listColumns.map((col, i) => (
                <ul key={i} className="feature-list">
                  {col.map((item, j) => (
                    <li key={j} className="FS16FW500 fw-normal" >{ReactHtmlParser(item)}</li>
                  ))}
                </ul>
              ))}
            </div>
          </>
        )}
        {listBottomText && (
          <div className="mt-3"><span className="quote-para FS17FW500">{ReactHtmlParser(listBottomText)}</span></div>
        )}
        {btnLink && btnText && (
          <ButtonComp link={btnLink} btnText={btnText} className={`${btnClassName || ""} mt-5`.trim()} img={btnImg} />
        )}
      </div>

      {/* RIGHT IMAGE */}
      {image && (
        <div className="col-lg-6 col-md-12 cis-image-col">
          <SkeletonImage
            className={`cis-image ${imageClassName || ""}`}
            src={image}
            alt="LA"
          />
        </div>
      )}
    </div>
  );
};

export default ContentImageSection;
